import { InjectionToken } from '@angular/core';
import { NavigationStrategyInterface } from '../interfaces/navigation-strategy.interface';
import { inject } from '@angular/core';
import { VerticalNavigationStrategyService } from './vertical-navigation-strategy.service';

export const NAVIGATION_STRATEGY = new InjectionToken<NavigationStrategyInterface>('NAVIGATION_STRATEGY', {
    providedIn: 'root',
    factory: () => inject(VerticalNavigationStrategyService),
});
